import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import List from '@mui/material/List'
import Stack from '@mui/material/Stack'

import { useBudgetsStore, useGlobalCopyStore } from '../../common'
import { type DetailedCategory } from '../../core'

import { Header } from './addbudget/Header'
import { RecalculateBudgets } from './addbudget/RecalculateBudgets'
import { UnbudgetedRow } from './addbudget/UnbudgetedRow'
import { buildDynamicCopy } from '../../core/utils/Localization'

interface AddBudgetsProps {
  onAddBudget?: () => void
  onRecalculateBudgets?: () => void
}

export const AddBudgets = observer(({ onAddBudget, onRecalculateBudgets }: AddBudgetsProps) => {
  const { budgets: copy } = useGlobalCopyStore()
  const { addBudget, setAlert, unbudgetedCategories } = useBudgetsStore()

  const handleOnAddBudget = async (category: DetailedCategory, amount: number) => {
    await addBudget(category, amount)
    onAddBudget?.()
    setAlert({
      msg: buildDynamicCopy(copy.alert_budget_created, category.name) as string,
      severity: 'success',
    })
  }

  return (
    <Stack>
      <Header />

      <Box bgcolor="background.paper">
        <List>
          {unbudgetedCategories.map((category) => (
            <UnbudgetedRow
              category={category}
              key={category.guid}
              onAddBudget={handleOnAddBudget}
            />
          ))}
        </List>
      </Box>

      <RecalculateBudgets onRecalculateBudgets={onRecalculateBudgets} />
    </Stack>
  )
})
